<template lang="html">
	<tr>
		<table-cell class="tag-table-name">
			<div class="tag-table-name__title">
				<core-button @click.prevent="go()" :isLink="true" :linkStyle="true" class="omapi-button__link-title">{{ tag.name }}</core-button>
			</div>
		</table-cell>
		<table-cell class="tag-table-created">
			{{ created }}
		</table-cell>
		<table-cell class="tag-table-stats">
			<core-button @click.prevent="go()" :isLink="true" :linkStyle="true">{{ allTime }}</core-button>
		</table-cell>
		<table-cell class="tag-table-stats">
			<core-button @click.prevent="go('30-days')" :isLink="true" :linkStyle="true">{{ last30 }}</core-button>
		</table-cell>
	</tr>
</template>

<script lang="js">
import format from 'date-fns/format'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('monsterleads')

export default  {
	props : {
		tag : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		allTime () {
			return this.$get('tag.leads_count_all_time', 0) || 0
		},
		last30 () {
			return this.$get('tag.leads_count_30_days', 0) || 0
		},
		created () {
			return format(new Date(this.tag.created), 'MMMM do, yyyy, h:mmaaa')
		},
	},
	methods : {
		...mapActions([ 'fetchLeadsFromDateRange', 'goToTagFilteredPage' ]),
		go (filter = '') {
			this.goToTagFilteredPage(this.$get('tag.id', 0))
			this.fetchLeadsFromDateRange({
				filter,
				start : '',
				end   : '',
			})
		},
	},
}
</script>
